import apiClient from './api';

export default {
    async getProducts(params = {}) {
        try {
            const response = await apiClient.get('/products', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching products:', error);
            throw error;
        }
    },

    async getProduct(id) {
        try {
            const response = await apiClient.get(`/products/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching product ${id}:`, error);
            throw error;
        }
    },

    async createProduct(data) {
        return apiClient.post('/products', data);
    },

    async updateProduct(id, data) {
        return apiClient.put(`/products/${id}`, data);
    },

    async deleteProduct(id) {
        return apiClient.delete(`/products/${id}`);
    }
};
